/**
 * Front-end JavaScript
 *
 * The JavaScript code you place here will be processed by esbuild. The output
 * file will be created at `../theme/js/script.min.js` and enqueued in
 * `../theme/functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */
import $ from "jquery";
import axios from "axios";


$('.userInput').on('keyup', function() {
	axios.post(ajax_object.ajax_url, new URLSearchParams({
		'action': 'get_articles_titles',
		'keyword': document.getElementsByClassName('userInput')[0].value,
		'nonce': ajax_object.nonce
	}))
	.then(function (response) {
		response.data !== '' ? document.getElementById('datafetch').innerHTML = response.data : document.getElementById('datafetch').innerHTML = '';
		// hide div if no data
		if (response.data === '') {
			// add class hidden
			document.getElementById('datafetch').classList.add('hidden');
		} else {
			// remove class hidden
			document.getElementById('datafetch').classList.remove('hidden');
		}
	})
	.catch(function (error) {
		console.error(error);
	});
});

//
// $('#toggle-nav').on('click', function() {
// 	$('.mobile-nav').toggle('hidden');
//
// });
//
// $('#close-nav').on('click', function() {
// 	$('.mobile-nav').toggle('hidden');
//
// });
//
// $('.toggle-search').on('click', function() {
// 	$('#search').toggle('hidden');
// });



//alert(ajax_object.nonce);
// $(function($) {
//
// 	$('.userInput').on('keyup', function() {
// 		var input = $(this).val();
// 		if(input != '') {
// 			var data = {
// 				'action': 'get_articles_titles',
// 				'search_text': input,
// 				'nonce': ajax_object.nonce
// 			}
// 			$.post(ajax_object.url, data, function(response) {
// 				$('#datafetch').html(response);
// 			});
// 		}
// 	});
// });

